import { pipe } from '@vaaas/fpts/function';
import { inside } from '@vaaas/fpts/set';
import { to_upper_case, trim } from '@vaaas/fpts/string';

export function color_parser(x: unknown) {
    if (!is_number_or_string(x))
        return new InvalidColor();

    const y = pipe(
        x,
        to_hex_if_needed,
        trim,
        to_upper_case,
        add_hash_if_needed,
    );

    if (y.length !== 7)
        return new InvalidColor();
    else if ([y[1], y[2], y[3], y[4], y[5], y[6]].every(valid_hex_char))
        return y;
    else
        return new InvalidColor();
}

const valid_hex_char = inside(new Set('ABCDEF0123456789'));

const add_hash_if_needed = (x: string) => x.startsWith('#') ? x : '#' + x;

const to_hex_if_needed = (x: string | number): string => typeof x === 'number' ? x.toString(16) : x;

const is_number_or_string = (x: unknown): x is number | string => ['number', 'string'].includes(typeof x);

export class InvalidColor extends Error {
    constructor() {
        super('invalid color');
    }
}
